import type { ServicePage } from "./types";

export const emergenciaPages: ServicePage[] = [
  {
    slug: "chaveiro-betim",
    keyword: "chaveiro betim",
    title: "Chaveiro em Betim | Chavel — Desde 1975 | (31) 3531-3544",
    description:
      "Chaveiro em Betim desde 1975. Abertura de portas e carros, cópia de chaves, chave codificada, fechaduras e controles de portão. Av. Amazonas, 1354 - Brasiléia.",
    h1: "Chaveiro em Betim: atendimento rápido desde 1975",
    lead: "A Chavel é uma chavearia tradicional de Betim, na Av. Amazonas, 1354 - Lj 01, bairro Brasiléia. São mais de quatro décadas abrindo portas, copiando chaves e instalando fechaduras para moradores, condomínios e empresas da cidade.",
    category: "geral",
    quickAnswer:
      "A Chavel é um chaveiro em Betim (MG) localizado na Av. Amazonas, 1354 - Lj 01, Brasiléia, telefone e WhatsApp (31) 3531-3544. Atende abertura de portas, cópia de chaves comuns e codificadas, chaves automotivas, fechaduras e controles de portão, com atendimento em loja e a domicílio em toda Betim.",
    sections: [
      {
        h2: "Serviços de chaveiro que a Chavel faz em Betim",
        paragraphs: [
          "Trabalhamos com o serviço completo de chavearia: da cópia simples de uma chave de porta até a programação de chave codificada de carro e a instalação de fechadura digital. O atendimento pode ser feito na loja, no bairro Brasiléia, ou no local onde você estiver dentro de Betim.",
        ],
        bullets: [
          "Abertura de portas residenciais, comerciais e de veículos sem danificar a fechadura",
          "Cópia de chaves comuns, tetra, gorge, multiponto e codificadas",
          "Troca e conserto de fechaduras de madeira, alumínio, vidro e portas blindadas",
          "Instalação de fechadura digital, eletrônica e elétrica para portões",
          "Cópia e programação de controles de portão eletrônico",
          "Confecção de carimbos, chaveiros personalizados e afiação",
        ],
      },
      {
        h2: "Por que escolher a Chavel entre os chaveiros de Betim",
        paragraphs: [
          "Chaveiro é serviço de confiança: alguém vai abrir a porta da sua casa ou do seu carro. Estar há décadas no mesmo endereço, com loja física e ficha verificada no Google, é o que separa um profissional sério de um anúncio genérico.",
        ],
        h3: [
          {
            title: "Loja física em Betim",
            text: "Endereço fixo na Av. Amazonas, 1354 - Lj 01, Brasiléia, fácil de localizar e com estacionamento nas proximidades.",
          },
          {
            title: "Desde 1975 na cidade",
            text: "Mais de 45 anos de experiência com fechaduras antigas, portas de madeira, sistemas modernos e veículos nacionais e importados.",
          },
          {
            title: "Avaliação 4,5 no Google",
            text: "São 55 avaliações de clientes de Betim que já usaram o serviço, com nota média 4,5.",
          },
        ],
      },
      {
        h2: "Quanto custa um chaveiro em Betim?",
        paragraphs: [
          "O valor depende do serviço: uma cópia de chave simples custa poucos reais, enquanto abertura de veículo, chave codificada e instalação de fechadura digital variam conforme o modelo. A Chavel informa o preço antes de executar o serviço — basta enviar pelo WhatsApp o que você precisa, o modelo da fechadura ou do carro e o bairro.",
        ],
      },
      {
        h2: "Atendimento em toda Betim",
        paragraphs: [
          "Além do Centro e do Brasiléia, atendemos Alterosa, Angola, Guarujá, Ingá, Dom Bosco, Jardim Teresópolis, Icaivera, Bandeirinhas, Vianópolis, Citrolândia, PTB e demais regiões da cidade.",
        ],
      },
    ],
    faq: [
      {
        q: "Onde fica a Chavel chaveiro em Betim?",
        a: "Av. Amazonas, 1354 - Lj 01, Brasiléia, Betim - MG, CEP 32600-324. O telefone e o WhatsApp são (31) 3531-3544.",
      },
      {
        q: "Qual o horário de funcionamento?",
        a: "De segunda a sexta das 08:00 às 18:00 e aos sábados das 08:00 às 13:00. Domingo fechado. Para urgências fora do horário, chame pelo WhatsApp.",
      },
      {
        q: "A Chavel atende a domicílio?",
        a: "Sim. O chaveiro se desloca até sua casa, empresa ou onde o veículo estiver, dentro de Betim e região.",
      },
      {
        q: "Precisa comprovar que sou o dono do imóvel ou do carro?",
        a: "Sim. Por segurança, pedimos documento e alguma comprovação de vínculo com o imóvel ou veículo antes da abertura.",
      },
    ],
    related: ["chaveiro-24-horas-betim", "chaveiro-betim-centro", "chaveiro-automotivo-betim", "chaveiro-a-domicilio"],
  },
  {
    slug: "chaveiro-perto-de-mim",
    keyword: "chaveiro perto de mim",
    title: "Chaveiro Perto de Mim em Betim | Chavel | (31) 3531-3544",
    description:
      "Procurando chaveiro perto de mim em Betim? A Chavel fica na Av. Amazonas, 1354 - Brasiléia e vai até você em toda a cidade. Chame no WhatsApp.",
    h1: "Chaveiro perto de mim em Betim",
    lead: "Quando a porta bate ou a chave quebra, o que importa é quem chega primeiro. A Chavel fica em ponto central de Betim, na Av. Amazonas, e envia o chaveiro até o seu endereço.",
    category: "emergencia",
    quickAnswer:
      "Se você está em Betim e procura um chaveiro perto de você, a Chavel atende pelo WhatsApp (31) 3531-3544 e fica na Av. Amazonas, 1354 - Lj 01, Brasiléia — via de acesso rápido ao Centro, Angola, Alterosa, Brasiléia e bairros vizinhos.",
    sections: [
      {
        h2: "Como escolher o chaveiro mais perto de você",
        paragraphs: [
          "A busca por “chaveiro perto de mim” devolve muitos anúncios sem endereço. Antes de chamar, confira três coisas: se existe endereço físico verificável, se o telefone é fixo da cidade e se o preço é informado antes do serviço.",
        ],
        bullets: [
          "Endereço real: Av. Amazonas, 1354 - Lj 01, Brasiléia, Betim - MG",
          "Telefone fixo local: (31) 3531-3544, o mesmo no WhatsApp",
          "Ficha verificada no Google com nota 4,5 e 55 avaliações",
          "Orçamento passado antes de qualquer serviço",
        ],
      },
      {
        h2: "Quanto tempo o chaveiro leva para chegar",
        paragraphs: [
          "Dentro de Betim, o deslocamento normalmente fica entre 15 e 40 minutos, variando com o bairro e o trânsito na Av. Amazonas e na MG-050. Ao chamar, informe o bairro, um ponto de referência e o tipo de porta ou veículo: isso permite levar a ferramenta certa e resolver em uma única visita.",
        ],
      },
      {
        h2: "O que enviar na primeira mensagem",
        paragraphs: [
          "Quanto mais claro o pedido, mais rápida a resposta. Envie o serviço (abertura, cópia, troca de fechadura), o bairro e, se possível, uma foto da fechadura ou o modelo e ano do carro.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês atendem no meu bairro?",
        a: "Atendemos toda Betim, incluindo Centro, Brasiléia, Alterosa, Angola, Guarujá, Ingá, Dom Bosco, Icaivera, Citrolândia e Jardim Teresópolis.",
      },
      {
        q: "Tem taxa de deslocamento?",
        a: "Serviços a domicílio podem ter taxa conforme a distância. O valor total é informado por WhatsApp antes do envio do profissional.",
      },
      {
        q: "Posso ir até a loja em vez de chamar em casa?",
        a: "Sim, e costuma sair mais barato. Cópias de chave, controles e venda de fechaduras são feitos na loja da Av. Amazonas, 1354.",
      },
    ],
    related: ["chaveiro-mais-proximo", "chaveiro-proximo-a-mim", "chaveiro-betim", "chaveiro-urgente"],
  },
  {
    slug: "chaveiro-24-horas",
    keyword: "chaveiro 24 horas",
    title: "Chaveiro 24 Horas | Chavel Betim | (31) 3531-3544",
    description:
      "Chaveiro 24 horas para abertura de portas e veículos em Betim. Fale agora pelo WhatsApp (31) 3531-3544 e receba orientação imediata.",
    h1: "Chaveiro 24 horas: o que fazer quando você fica trancado",
    lead: "Porta batida com a chave dentro, chave quebrada no segredo ou carro trancado com o motor ligado. Emergência de chaveiro não escolhe horário, e a primeira decisão certa evita prejuízo maior.",
    category: "emergencia",
    quickAnswer:
      "Para atendimento de chaveiro 24 horas em Betim, chame a Chavel pelo WhatsApp (31) 3531-3544. Emergências fora do horário de loja (seg a sex 08:00–18:00, sáb 08:00–13:00) são avaliadas caso a caso e atendidas mediante confirmação.",
    sections: [
      {
        h2: "Situações que exigem chaveiro imediato",
        paragraphs: [
          "Nem toda situação é emergência real. Saber diferenciar ajuda a decidir entre chamar agora ou esperar o horário comercial, quando o serviço custa menos.",
        ],
        bullets: [
          "Criança, idoso ou animal trancado dentro do imóvel ou do carro — emergência absoluta",
          "Fogão ou forno ligado com a porta trancada",
          "Chave quebrada dentro do segredo com a porta aberta ao público",
          "Arrombamento ou tentativa de furto com a fechadura comprometida",
          "Perda de chave única de veículo em local de risco",
        ],
      },
      {
        h2: "O que NÃO fazer enquanto espera",
        paragraphs: [
          "A maior parte dos danos que vemos foi causada na tentativa de resolver sozinho. Arame no miolo, chave de fenda na fresta e cartão forçado normalmente quebram o cilindro e transformam uma abertura simples em troca completa de fechadura.",
        ],
        bullets: [
          "Não force o segredo com objetos improvisados",
          "Não arrombe a porta: o reparo da madeira costuma custar mais que o serviço",
          "Não puxe a chave quebrada com alicate sem apoio",
          "Não chame quem não informa nome, endereço e preço antes",
        ],
      },
      {
        h2: "Como funciona o atendimento de urgência da Chavel",
        paragraphs: [
          "Você envia a mensagem descrevendo a situação e o local. Confirmamos a viabilidade e o valor, o profissional se desloca, verifica a titularidade do imóvel ou veículo e executa a abertura com técnica não destrutiva sempre que possível.",
        ],
      },
    ],
    faq: [
      {
        q: "Chaveiro 24 horas cobra mais caro?",
        a: "Atendimentos fora do horário comercial, em feriados e de madrugada têm valor diferenciado por causa do deslocamento e da urgência. O preço é informado antes.",
      },
      {
        q: "A abertura danifica a fechadura?",
        a: "Na maioria dos casos usamos técnica não destrutiva e a fechadura continua funcionando. Em fechaduras travadas ou danificadas pode ser necessário substituir o cilindro.",
      },
      {
        q: "Vocês abrem qualquer porta?",
        a: "Abrimos após comprovação de que você é morador, responsável ou proprietário. Sem comprovação, o serviço não é executado.",
      },
    ],
    related: ["chaveiro-24-horas-betim", "chaveiro-betim-24hs", "chaveiro-urgente", "chaveiro-betim"],
  },
  {
    slug: "chaveiro-24-horas-betim",
    keyword: "chaveiro 24 horas betim",
    title: "Chaveiro 24 Horas em Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro 24 horas em Betim: abertura de porta, abertura de carro e troca de fechadura em emergência. WhatsApp (31) 3531-3544.",
    h1: "Chaveiro 24 horas em Betim",
    lead: "Ficar do lado de fora de casa à noite em Betim é mais comum do que parece. A Chavel atende emergências de abertura em toda a cidade, com profissional identificado e valor combinado antes.",
    category: "emergencia",
    quickAnswer:
      "A Chavel atende chamados de chaveiro 24 horas em Betim pelo WhatsApp (31) 3531-3544, com deslocamento a partir da Av. Amazonas, 1354 - Brasiléia para Centro, Alterosa, Angola, Guarujá, Ingá, Dom Bosco, Icaivera e demais bairros.",
    sections: [
      {
        h2: "Emergências mais chamadas em Betim",
        paragraphs: [
          "O padrão de chamados na cidade se repete: portas de apartamento que batem com o vento nos condomínios do Angola e do Guarujá, chaves esquecidas dentro do carro em estacionamentos do Centro e fechaduras antigas que travam em casas de madeira nos bairros mais tradicionais.",
        ],
        bullets: [
          "Abertura de porta residencial com chave dentro de casa",
          "Abertura de veículo com chave trancada no interior",
          "Fechadura travada que não gira em nenhum sentido",
          "Troca urgente de segredo após perda de chave ou mudança",
        ],
      },
      {
        h2: "Cobertura de bairros no atendimento noturno",
        paragraphs: [
          "O deslocamento noturno prioriza áreas com acesso pela Av. Amazonas, MG-050 e Via Betim. Bairros mais distantes, como Citrolândia e Icaivera, também são atendidos, com tempo de chegada maior.",
        ],
      },
      {
        h2: "Segurança no atendimento de madrugada",
        paragraphs: [
          "Trabalhamos com identificação do profissional e verificação de titularidade. Nunca abrimos um imóvel para quem não comprova vínculo — é isso que protege você quando o pedido não parte de você.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês atendem de madrugada em Betim?",
        a: "Chamados de urgência fora do horário de loja são avaliados pelo WhatsApp (31) 3531-3544 e confirmados conforme disponibilidade do profissional.",
      },
      {
        q: "Quanto tempo demora para chegar à noite?",
        a: "Sem trânsito, o deslocamento dentro de Betim costuma ficar entre 20 e 40 minutos.",
      },
      {
        q: "Posso pagar por Pix?",
        a: "Sim, aceitamos Pix, dinheiro e cartão.",
      },
    ],
    related: ["chaveiro-betim-24hs", "chaveiro-24-horas", "chaveiro-urgente", "chaveiro-betim"],
  },
  {
    slug: "chaveiro-betim-24hs",
    keyword: "chaveiro betim 24hs",
    title: "Chaveiro Betim 24hs | Abertura de Emergência | Chavel",
    description:
      "Chaveiro Betim 24hs para abertura de porta e carro, troca de segredo e fechadura arrombada. Atendimento pelo WhatsApp (31) 3531-3544.",
    h1: "Chaveiro Betim 24hs: atendimento de emergência",
    lead: "Se você digitou “chaveiro betim 24hs”, provavelmente está do lado de fora agora. Esta página resume o que fazer nos primeiros dez minutos e como falar com a Chavel.",
    category: "emergencia",
    quickAnswer:
      "Chame a Chavel no WhatsApp (31) 3531-3544, descreva a situação (porta, carro ou fechadura travada), informe o bairro em Betim e aguarde a confirmação de valor e tempo de chegada.",
    sections: [
      {
        h2: "Primeiros passos antes de chamar",
        paragraphs: [
          "Confirme se realmente não há outra entrada aberta, se um vizinho ou familiar tem cópia e se a chave não ficou na fechadura pelo lado de dentro — esse detalhe muda a técnica de abertura e o valor do serviço.",
        ],
        bullets: [
          "Verifique portas de serviço, janelas e portão dos fundos",
          "Confira se há cópia com síndico, portaria ou parente",
          "Observe se a chave está inserida pelo lado interno",
          "Tenha em mãos um documento com seu endereço",
        ],
      },
      {
        h2: "Abertura de porta com chave presa por dentro",
        paragraphs: [
          "Quando a chave fica no segredo pelo lado interno, a abertura exige ferramenta específica para girar o tambor a partir do outro lado. É um serviço técnico e, feito corretamente, não danifica a porta.",
        ],
      },
      {
        h2: "Depois da abertura: vale trocar o segredo?",
        paragraphs: [
          "Se a chave foi perdida na rua, sim. Trocar apenas o cilindro é rápido e barato comparado à troca da fechadura inteira, e evita que quem achou a chave tenha acesso ao imóvel.",
        ],
      },
    ],
    faq: [
      {
        q: "Qual a diferença entre trocar o segredo e trocar a fechadura?",
        a: "Trocar o segredo é substituir apenas o cilindro, mantendo a fechadura instalada. Trocar a fechadura é substituir todo o conjunto, indicado quando há desgaste ou dano.",
      },
      {
        q: "Vocês emitem nota fiscal?",
        a: "Sim, a Chavel é empresa estabelecida em Betim e emite documento fiscal do serviço.",
      },
      {
        q: "Atendem condomínios e portarias?",
        a: "Sim, incluindo troca de fechaduras de áreas comuns e cópia de chaves para administração.",
      },
    ],
    related: ["chaveiro-24-horas-betim", "chaveiro-24-horas", "chaveiro-betim-centro", "chaveiro-urgente"],
  },
  {
    slug: "chaveiro-betim-centro",
    keyword: "chaveiro betim centro",
    title: "Chaveiro no Centro de Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no Centro de Betim: cópia de chaves, abertura de portas, fechaduras e controles. Loja na Av. Amazonas, 1354 - Brasiléia, a minutos do Centro.",
    h1: "Chaveiro no Centro de Betim",
    lead: "O Centro de Betim concentra comércio, escritórios e prédios antigos — e cada um desses cenários tem uma necessidade diferente de chavearia. A Chavel atende a região a partir da Av. Amazonas, 1354.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o Centro de Betim com abertura de portas, cópia de chaves, troca de fechaduras e controles de portão. A loja fica na Av. Amazonas, 1354 - Lj 01, Brasiléia, poucos minutos do Centro. WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Serviços mais pedidos no Centro",
        paragraphs: [
          "No comércio central, o volume maior é de cópia de chaves para funcionários, troca de fechaduras de loja e reparo de portas de vidro temperado. Nos prédios residenciais antigos, predominam fechaduras de gorge e cilindros desgastados.",
        ],
        bullets: [
          "Fechaduras para porta de vidro temperado de loja",
          "Cadeados e barras antipânico para comércio",
          "Cópias em lote para equipes e portarias",
          "Troca de cilindro após saída de funcionário",
        ],
      },
      {
        h2: "Segurança para lojas e escritórios",
        paragraphs: [
          "Estabelecimentos comerciais no Centro se beneficiam de fechaduras de alta rotatividade e de controle de acesso simples: fechadura eletrônica com senha evita o custo de trocar o segredo cada vez que alguém deixa a equipe.",
        ],
      },
      {
        h2: "Como chegar até a loja",
        paragraphs: [
          "Saindo do Centro pela Av. Amazonas sentido Brasiléia, a Chavel fica no número 1354, loja 01, no Ed. Carino Saraiva. São cerca de 15 minutos de carro e 3 minutos a pé de quem já está no bairro.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês fazem cópia de chave na hora?",
        a: "Sim, chaves comuns e de cadeado saem na hora na loja. Chaves codificadas e multiponto podem exigir agendamento.",
      },
      {
        q: "Atendem lojas do Centro no mesmo dia?",
        a: "Sim, dentro do horário comercial fazemos atendimento no local para comércio do Centro de Betim.",
      },
      {
        q: "Trabalham com barra antipânico?",
        a: "Sim, fornecemos e instalamos barras antipânico exigidas pelo Corpo de Bombeiros em estabelecimentos comerciais.",
      },
    ],
    related: ["chaveiro-betim", "chaveiro-brasileia", "fechaduras-de-porta", "chaveiro-24-horas-betim"],
  },
  {
    slug: "chaveiro-mais-proximo",
    keyword: "chaveiro mais próximo",
    title: "Chaveiro Mais Próximo em Betim | Chavel | (31) 3531-3544",
    description:
      "Encontre o chaveiro mais próximo em Betim: loja física na Av. Amazonas, 1354 - Brasiléia e atendimento a domicílio em toda a cidade.",
    h1: "Chaveiro mais próximo em Betim: como encontrar",
    lead: "Distância importa, mas capacidade técnica importa mais. Um chaveiro a dez minutos que não trabalha com o seu tipo de fechadura vai embora sem resolver.",
    category: "emergencia",
    quickAnswer:
      "O chaveiro mais próximo em Betim para quem está na região central e no eixo da Av. Amazonas é a Chavel, na Av. Amazonas, 1354 - Lj 01, Brasiléia. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Três critérios além da distância",
        paragraphs: [
          "Antes de decidir pelo mais perto, confirme se o profissional cobre o seu caso específico. Chave codificada, fechadura multiponto e portão automático exigem equipamento diferente.",
        ],
        h3: [
          {
            title: "Tipo de serviço",
            text: "Abertura residencial, automotiva e instalação de fechadura digital usam ferramentas distintas. Diga o que precisa logo na primeira mensagem.",
          },
          {
            title: "Prova de existência",
            text: "Endereço físico, telefone fixo e avaliações reais no Google. A Chavel tem os três e nota 4,5 com 55 avaliações.",
          },
          {
            title: "Preço antes do serviço",
            text: "Orçamento fechado antes do deslocamento evita a surpresa clássica de valor inflado na hora do pagamento.",
          },
        ],
      },
      {
        h2: "Rotas de atendimento em Betim",
        paragraphs: [
          "A partir do Brasiléia, o acesso é rápido para Centro, Angola, Alterosa, Ingá, Guarujá e Dom Bosco pela Av. Amazonas. Bairros ligados pela MG-050 também são atendidos.",
        ],
      },
    ],
    faq: [
      {
        q: "Como sei se vocês são os mais próximos de mim?",
        a: "Envie sua localização pelo WhatsApp (31) 3531-3544. Informamos o tempo estimado de chegada antes de você fechar o serviço.",
      },
      {
        q: "Fazem atendimento em cidades vizinhas?",
        a: "O foco é Betim. Regiões limítrofes são avaliadas conforme a distância.",
      },
    ],
    related: ["chaveiro-perto-de-mim", "chaveiro-proximo-a-mim", "chaveiro-a-domicilio", "chaveiro-betim"],
  },
  {
    slug: "chaveiro-proximo-a-mim",
    keyword: "chaveiro próximo a mim",
    title: "Chaveiro Próximo a Mim — Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro próximo a mim em Betim com loja física e atendimento móvel. Abertura, cópia de chaves e fechaduras. WhatsApp (31) 3531-3544.",
    h1: "Chaveiro próximo a mim: atendimento em Betim",
    lead: "Você não precisa se deslocar com a porta trancada. Informe o bairro e o chaveiro vai até você em qualquer região de Betim.",
    category: "emergencia",
    quickAnswer:
      "A Chavel é um chaveiro com loja em Betim (Av. Amazonas, 1354 - Brasiléia) que também atende no local do cliente em toda a cidade. Chame pelo WhatsApp (31) 3531-3544 informando bairro e serviço.",
    sections: [
      {
        h2: "Atendimento móvel x atendimento na loja",
        paragraphs: [
          "Serviços que exigem a fechadura ou o veículo presente são feitos no local. Já cópias de chave, controles de portão e compra de fechaduras saem mais rápido e mais barato na loja.",
        ],
        bullets: [
          "No local: abertura de porta, abertura de carro, instalação e troca de fechadura, chave codificada no veículo",
          "Na loja: cópia de chaves, clonagem de controles, venda de fechaduras e cadeados, carimbos",
        ],
      },
      {
        h2: "Informações que aceleram o atendimento",
        paragraphs: [
          "Uma foto da fechadura ou do miolo, o modelo e ano do carro e o ponto de referência do bairro reduzem o tempo de resolução e permitem orçamento imediato.",
        ],
      },
    ],
    faq: [
      {
        q: "Preciso agendar?",
        a: "Para urgências, não. Para instalação de fechadura digital e serviços maiores, o agendamento garante horário.",
      },
      {
        q: "Vocês atendem empresas com contrato mensal?",
        a: "Sim, condomínios e empresas de Betim podem contratar atendimento recorrente.",
      },
    ],
    related: ["chaveiro-perto-de-mim", "chaveiro-mais-proximo", "chaveiro-a-domicilio", "chaveiro-urgente"],
  },
  {
    slug: "chaveiro-urgente",
    keyword: "chaveiro urgente",
    title: "Chaveiro Urgente em Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro urgente em Betim para abertura imediata de portas e veículos. Fale agora no WhatsApp (31) 3531-3544 e receba orientação.",
    h1: "Chaveiro urgente em Betim",
    lead: "Urgência de chaveiro tem uma característica: cada tentativa errada aumenta o custo. Esta página mostra como agir e como acionar a Chavel imediatamente.",
    category: "emergencia",
    quickAnswer:
      "Para chaveiro urgente em Betim, envie mensagem para (31) 3531-3544 informando: o que aconteceu, endereço com ponto de referência e se há pessoa, criança ou animal preso no local.",
    sections: [
      {
        h2: "Classificando a urgência",
        paragraphs: [
          "Nem tudo precisa ser resolvido em minutos. Separar o urgente do incômodo ajuda a economizar e a priorizar quem realmente precisa de atendimento imediato.",
        ],
        bullets: [
          "Crítico: pessoa ou animal preso, fogo/fogão ligado, risco de segurança",
          "Alto: imóvel aberto e desprotegido, chave perdida na rua, comércio sem fechar",
          "Médio: fechadura emperrada com acesso alternativo disponível",
          "Baixo: cópia de chave, manutenção preventiva, troca programada",
        ],
      },
      {
        h2: "Erros que encarecem o serviço",
        paragraphs: [
          "Forçar o segredo com chave torta, aplicar óleo de cozinha no cilindro e tentar arrombar a porta são as três causas mais comuns de troca completa de fechadura. Lubrificante correto é grafite ou produto específico, nunca óleo comestível.",
        ],
      },
      {
        h2: "Prevenção depois da emergência",
        paragraphs: [
          "Depois de resolver, deixe uma cópia com alguém de confiança, considere uma fechadura digital com senha temporária e faça manutenção do cilindro a cada dois anos.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês atendem chamado urgente no sábado à tarde?",
        a: "A loja fecha às 13:00 no sábado, mas chamados urgentes podem ser avaliados pelo WhatsApp.",
      },
      {
        q: "Consigo orçamento por telefone?",
        a: "Sim, para a maioria dos casos conseguimos estimar o valor com a descrição e uma foto.",
      },
    ],
    related: ["chaveiro-24-horas", "chaveiro-24-horas-betim", "chaveiro-perto-de-mim", "chaveiro-a-domicilio"],
  },
  {
    slug: "chaveiro-a-domicilio",
    keyword: "chaveiro a domicílio",
    title: "Chaveiro a Domicílio em Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro a domicílio em Betim: o profissional vai até sua casa ou empresa para abrir, trocar ou instalar fechaduras. WhatsApp (31) 3531-3544.",
    h1: "Chaveiro a domicílio em Betim",
    lead: "Troca de fechadura, instalação de fechadura digital, abertura de porta e cópia de chave de porta blindada: tudo isso pode ser feito na sua casa, sem você sair.",
    category: "geral",
    quickAnswer:
      "A Chavel faz atendimento a domicílio em Betim para abertura de portas, troca e instalação de fechaduras, chaves automotivas e controles de portão. Agende pelo WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Serviços feitos na sua casa",
        paragraphs: [
          "O atendimento a domicílio cobre praticamente tudo que exige a porta ou o veículo presentes.",
        ],
        bullets: [
          "Abertura de porta sem danos",
          "Troca de cilindro e de fechadura completa",
          "Instalação de fechadura digital e eletrônica",
          "Instalação de fechadura elétrica em portão",
          "Reparo de maçaneta, testa e batente",
          "Programação de chave codificada no veículo",
        ],
      },
      {
        h2: "Como funciona a visita",
        paragraphs: [
          "Você descreve o serviço pelo WhatsApp e recebe uma estimativa. Na chegada, o profissional confere a situação, confirma o valor final e só então executa. Não há cobrança de serviço não autorizado.",
        ],
      },
      {
        h2: "Atendimento para condomínios",
        paragraphs: [
          "Síndicos e administradoras de Betim podem contratar troca de fechaduras de áreas comuns, padronização de chaves e cópias em lote com agendamento único.",
        ],
      },
    ],
    faq: [
      {
        q: "Qual o horário para agendar visita?",
        a: "Segunda a sexta das 08:00 às 18:00 e sábado das 08:00 às 13:00.",
      },
      {
        q: "Vocês levam a fechadura nova na visita?",
        a: "Sim. Informe a marca, o modelo ou envie uma foto e levamos a peça compatível.",
      },
      {
        q: "Fazem instalação de fechadura comprada por mim?",
        a: "Fazemos, cobrando apenas a mão de obra da instalação.",
      },
    ],
    related: ["chaveiro-betim", "fechadura-digital", "fechaduras-de-porta", "chaveiro-proximo-a-mim"],
  },
];
